import React, { FC } from 'react';

import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { WarningIcon } from '@assets/icons';

import { ErrorMessageWrapper, ErrorMessageLabel } from './ErrorMessageStyle';

export { ErrorMessageWrapper };
interface ErrorMessageProps {
  icon?:
    | React.ComponentType<
        CustomIconComponentProps | React.SVGProps<SVGSVGElement>
      >
    | undefined;
  message?: string;
  showIcon?: boolean;
  labelStyle?: React.CSSProperties;
}

const ErrorMessage: FC<ErrorMessageProps> = ({
  message,
  icon = WarningIcon,
  showIcon = true,
  labelStyle,
}) => {
  return (
    <ErrorMessageWrapper showIcon={showIcon}>
      <Icon component={icon} />
      <ErrorMessageLabel style={labelStyle}>{message}</ErrorMessageLabel>
    </ErrorMessageWrapper>
  );
};

export default ErrorMessage;
